module.exports = __webpack_public_path__ + "static/media/loading6.0d7cf29c.gif";